export function cn(...classNames: Array<string | false | null | undefined>) {
    return classNames.filter(Boolean).join(' ');
}

export function preferLocalized(
    localized: string | null | undefined,
    fallback: string | null | undefined
): string | null {
    const localizedValue = localized?.trim();
    if (localizedValue) {
        return localizedValue;
    }

    return fallback?.trim() || null;
}
